import {useEffect, useRef, useState} from "react";
import useWindowDimensions from "../hooks/WindowDimensionsHook";

const TitleUnderlined = ({title, color = "black", bold = false, fontSize = "1rem", marginBottomText = 5, className}) => {
  const {width, height} = useWindowDimensions();
  const ref = useRef(null);
  const [lineWidth, setLineWidth] = useState(200);

  useEffect(() => {
    setLineWidth(ref.current.offsetWidth);
  }, [width, height])

  return (
    <div style={{display: "flex", flexDirection: "column", alignItems: "center"}} className={className}>
      <h1 
      style={{
        color: color,
        fontWeight: bold ? "bold" : 300,
        fontFamily: "Lora",
        fontSize: fontSize,
        marginBottom: marginBottomText,
        marginTop: 0,
      }}
      ref={ref}>
        {title}
      </h1>
      {ref.current ? <div 
        style={{
            height: bold ? 3 : 1,
            width: lineWidth * 0.9,
            backgroundColor: color,
        }}
      /> : null}
    </div>
  )
}

export default TitleUnderlined
